import { useState, useCallback } from "react";

export interface FileDragHandlers {
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
}

interface UseFileDragAndDropOptions {
  onDrop: (files: FileList) => void | Promise<void>;
  isDisabled?: boolean;
}

export const useFileDragAndDrop = ({
  onDrop,
  isDisabled = false,
}: UseFileDragAndDropOptions) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback(
    (e: React.DragEvent) => {
      if (isDisabled) return;
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(true);
    },
    [isDisabled],
  );

  const handleDragLeave = useCallback(
    (e: React.DragEvent) => {
      if (isDisabled) return;
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
    },
    [isDisabled],
  );

  const handleDrop = useCallback(
    async (e: React.DragEvent) => {
      if (isDisabled) return;
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);

      const files = e.dataTransfer.files;
      if (files.length > 0) {
        await onDrop(files);
      }
    },
    [isDisabled, onDrop],
  );

  return {
    isDragging,
    dragHandlers: {
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
    },
  };
};
